import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, Instagram, Music, Youtube, ArrowRight } from 'lucide-react';
import { reportsApi } from '../lib/reportsApi';
import { PageHeader, SectionCard, Button, Input, Badge } from '../components/ui/light';

export default function NewReport() {
  const navigate = useNavigate();
  const [profileUrl, setProfileUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!profileUrl.trim()) {
      setError('Please paste a profile URL');
      return;
    }
    setLoading(true);
    try {
      const res = await reportsApi.generate({ profile_url: profileUrl.trim() });
      navigate(`/reports/${res.data.report_id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Something went wrong');
      setLoading(false);
    }
  };

  return (
    <div className="theme-light l-page">
      <div className="l-shell py-10 max-w-3xl">
        <PageHeader
          eyebrow="New report"
          title="Generate a creator report"
          subtitle="Paste any Instagram, TikTok, or YouTube profile link. We'll do the rest in 30 seconds."
          back={{ label: 'My reports', onClick: () => navigate('/reports') }}
        />

        <SectionCard variant="elevated">
          <form onSubmit={submit} className="space-y-5">
            <Input
              label="Profile URL"
              placeholder="https://instagram.com/handle"
              value={profileUrl}
              onChange={(e) => setProfileUrl(e.target.value)}
              hint="We support Instagram, TikTok, and YouTube."
              error={error || undefined}
              autoFocus
            />

            <div className="flex items-center gap-2 flex-wrap">
              <Badge variant="neutral"><Instagram className="w-3 h-3 mr-1 inline" />Instagram</Badge>
              <Badge variant="neutral"><Music className="w-3 h-3 mr-1 inline" />TikTok</Badge>
              <Badge variant="neutral"><Youtube className="w-3 h-3 mr-1 inline" />YouTube</Badge>
            </div>

            <Button
              type="submit"
              variant="accent"
              size="lg"
              loading={loading}
              iconLeft={<Sparkles className="w-4 h-4" />}
              iconRight={<ArrowRight className="w-4 h-4" />}
            >
              Generate report
            </Button>
          </form>
        </SectionCard>
      </div>
    </div>
  );
}
